module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.eot
// module chunks = styles